const illusData = [
  {
    id: 1,
    src: "./Illustration/XXX.jpg",
  },
  {
    id: 2,
    src: "./Illustration/Messi.jpg",
  },
  {
    id: 3,
    src: "./Illustration/Model.jpg",
  },
  {
    id: 4,
    src: "./Illustration/Juice.jpg",
  },
  {
    id: 5,
    src: "./Illustration/KGF.jpg",
  },
  {
    id: 6,
    src: "./Illustration/Practice.jpg",
  },

  {
    id: 7,
    src: "./Illustration/Nawaz.jpg",
  },
  {
    id: 8,
    src: "./Illustration/Shiv.jpg",
  },

  {
    id: 9,
    src: "./Illustration/Martin.jpg",
  },

  {
    id: 10,
    src: "./Illustration/Neymar.jpg",
  },
  {
    id: 11,
    src: "./Illustration/Johnny.jpg",
  },
  {
    id: 12,
    src: "./Illustration/Zakir.jpg",
  },
  {
    id: 13,
    src: "./Illustration/Zayn.jpg",
  },
  {
    id: 14,
    src: "./Illustration/Ranvir.jpg",
  },
  {
    id: 15,
    src: "./Illustration/Pavilion.jpg",
  },
  {
    id: 16,
    src: "./Illustration/Sharaddha.jpg",
  },
];

export default illusData;
